import { createElement } from '@syncfusion/ej2-base';
var QuoteRenderer = /** @class */ (function () {
    function QuoteRenderer(manager) {
        this.parent = manager;
    }
    /**
     * Renders a quote block
     *
     * @param {BlockModel} block - The block model containing data.
     * @returns {HTMLElement} - The created or updated element.
     */
    QuoteRenderer.prototype.renderQuote = function (block) {
        var quoteProps = block.properties;
        quoteProps.placeholder = this.parent.getPlaceholderValue(block);
        var quoteElement = createElement('blockquote', {
            attrs: {
                contenteditable: 'true',
                placeholder: quoteProps.placeholder
            }
        });
        this.parent.blockRenderer.contentRenderer.renderContent(block, quoteElement);
        return quoteElement;
    };
    return QuoteRenderer;
}());
export { QuoteRenderer };
